import { Button } from "primereact/button";
import styles from "./FloatingFeedbackButton.module.css";
import { useEffect, useState } from "react";

export const FloatingFeedbackButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const lastHiddenDate = localStorage.getItem("feedbackButtonHidden");

    if (lastHiddenDate) {
      const hiddenDate = new Date(lastHiddenDate);
      const currentDate = new Date();

      // Calculate difference in days properly
      const diffTime = currentDate.getTime() - hiddenDate.getTime();
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

      // Hide if less than 5 days have passed
      setIsVisible(diffDays >= 5);
    } else {
      setIsVisible(true);
    }
  }, []);

  const handleHideButton = () => {
    // Store current date in localStorage
    localStorage.setItem("feedbackButtonHidden", new Date().toISOString());
    setIsVisible(false);
  };

  // Don't render anything if button shouldn't be visible
  if (!isVisible) return null;

  return (
    <div className={styles.floatingButton}>
      <Button
        text
        icon="pi pi-comments"
        label="Feedback"
        onClick={() =>
          window.open("https://pantheon-ai.supahub.com/", "_blank")
        }
      />
      <Button
        icon="pi pi-times"
        text
        severity="secondary"
        onClick={handleHideButton}
      />
    </div>
  );
};
